module.exports = __webpack_public_path__ + "5974297c2dd57fd10df7f8ba6fee7d66.svg";